import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import asyncComponent from '../../util/AsyncFunc';

import AddTeam from './addteam/index'
import TeamList from './teamlist/index'

//auth
import {
    userIsAuthenticatedRedir, userIsNotAuthenticatedRedir,
    userIsAuthenticated, userIsNotAuthenticated, userIsSuperAdminRedir,
    userIsBoardAdminRedir, userIsCommitteeAdminRedir, userIsCheckerAdminRedir
} from '../auth'

const AddTeamProtected_ba = userIsBoardAdminRedir(AddTeam)
const TeamListProtected_ba = userIsBoardAdminRedir(TeamList)
const Team = ({ match }) => (
    <div className="app-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/team-list`} />
            <Route path={`${match.url}/add-team/:id?`} component={AddTeamProtected_ba} />
            <Route path={`${match.url}/team-list`} component={TeamListProtected_ba} />
        </Switch>
    </div>
);

export default Team;



// WEBPACK FOOTER //
// ./app/teamdetails/index.js